/**
 * Starts a request now and hands the same promise back to await later.
 *
 * The throwaway handler is the whole point. A promise that rejects while its caller is still
 * awaiting a different one counts as unhandled — the browser logs it and error tracking reports it
 * — even though the caller does await it a moment later. Attaching any handler marks it handled;
 * the original promise still rejects when awaited, so error handling is unchanged.
 *
 * Use it to fire independent requests together instead of one after another:
 *
 * ```ts
 * const treeRequest = startRequest(getTreeById(id, token));
 * const entitiesRequest = startRequest(getTreeEntities(id, token));
 * const tree = await treeRequest;      // render what the tree alone allows
 * const entities = await entitiesRequest;
 * ```
 */
export const startRequest = <T>(request: Promise<T>): Promise<T> => {
	request.catch((): void => undefined);

	return request;
};
